export default "__VITE_ASSET__Ci_jI_Nv__"